// =============================================================================
// Login — mesmo desenho do Fio (frontend/src/pages/Login.js), na paleta do Fênix.
//
// O que veio de lá: fundo com gradiente radial escuro, card único centralizado,
// olho para mostrar/ocultar senha, rodapé com o nome da empresa, botão que vira
// spinner enquanto envia.
//
// O que é próprio daqui: as duas linhas finais.
//   · "o mesmo usuário e senha dos outros portais" — porque aqui NÃO se entra
//     com código de vendedor. A senha do vendedor tem outro papel no Fênix: ela
//     é pedida ao iniciar o orçamento, e diz DE QUEM É A VENDA.
//   · "funciona com o Microuniverso fora do ar" — senão ninguém lembra de abrir
//     o Fênix justamente no dia em que ele existe para servir.
// =============================================================================

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { mensagemDeErro } from '../services/api';
import logo from '../assets/logo-centrao.png';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);

  async function enviar(e) {
    e.preventDefault();
    if (carregando) return;              // guard: o disabled sozinho não basta
    setErro('');
    setCarregando(true);
    try {
      await login(username, senha);
      navigate('/orcamento');
    } catch (err) {
      setErro(mensagemDeErro(err, 'Não foi possível entrar.'));
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'radial-gradient(circle at 30% 20%, #B85207 0%, #3A2409 45%, #170E04 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ width: '100%', maxWidth: 420, padding: '0 16px' }}>
        <div
          className="card p-4 p-md-5"
          style={{
            background: '#26180A',
            color: '#F5EDE1',
            border: '1px solid #462D11',
            borderRadius: 20,
            boxShadow: '0 24px 60px rgba(0,0,0,0.55), 0 0 0 1px rgba(234,106,8,0.10)',
          }}
        >
          <div className="text-center mb-4">
            {/* Logo do Centrão em 180px — a mesma medida do RH e do Comercial.
                Quem entra aqui precisa reconhecer a casa antes de reconhecer o
                sistema. O nome do produto vem depois, menor. */}
            <img
              src={logo}
              alt="Centrão Materiais de Construção"
              style={{ width: 180, height: 'auto', marginBottom: 18 }}
            />
            <h4 style={{ color: '#FF9538', fontWeight: 700, marginBottom: 2 }}>
              <i className="bi bi-fire me-2" />Fênix
            </h4>
            <p style={{ color: '#C0A88F', fontSize: '0.82rem', margin: 0 }}>
              Vendas do Centrão
            </p>
          </div>

          {erro && (
            <div className="alert alert-danger py-2 px-3" style={{ fontSize: '0.85rem' }}>
              {erro}
            </div>
          )}

          <form onSubmit={enviar}>
            <div className="mb-3">
              <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>
                Usuário
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="seu.usuario"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
                autoComplete="username"
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold" style={{ fontSize: '0.85rem' }}>
                Senha
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={mostrarSenha ? 'text' : 'password'}
                  className="form-control"
                  placeholder="••••••••"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required
                  autoComplete="current-password"
                  style={{ paddingRight: 42 }}
                />
                <button
                  type="button"
                  onClick={() => setMostrarSenha((v) => !v)}
                  aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                  title={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                  style={{
                    position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)',
                    background: 'transparent', border: 'none', cursor: 'pointer',
                    color: '#C0A88F', fontSize: '1.05rem', lineHeight: 1, padding: 4,
                  }}
                >
                  <i className={`bi ${mostrarSenha ? 'bi-eye-slash' : 'bi-eye'}`} />
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn w-100 fw-semibold"
              style={{
                background: 'linear-gradient(135deg, #FF8A1F 0%, #EA6A08 100%)',
                color: '#fff',
                border: 'none',
                padding: '10px',
                boxShadow: '0 8px 20px rgba(234,106,8,0.4)',
              }}
              disabled={carregando}
            >
              {carregando ? (
                <><span className="spinner-border spinner-border-sm me-2" />Entrando...</>
              ) : 'Entrar'}
            </button>
          </form>

          <div className="text-center mt-3" style={{ color: '#94806B', fontSize: '0.72rem' }}>
            Use o mesmo usuário e senha dos outros portais do Centrão
          </div>
          {/* Até 29/10/2026 aqui dizia "funciona mesmo com o Microuniverso fora do
              ar" — era verdade na versão VPS, aposentada. O Fênix agora lê o ERP
              ao vivo e cai junto com ele. */}
          <div className="text-center mt-2" style={{ color: '#77654F', fontSize: '0.7rem' }}>
            <i className="bi bi-lightning-charge me-1" />O orçamento vai direto para o Microuniverso
          </div>
        </div>
      </div>
    </div>
  );
}
